/**
 * @namespace StringHelper 
 */
const StringHelper = {
    /**
     * Converts a camelCase string to kebab-case.
     * @param {string} str - The camelCase string to convert.
     * @returns {string} The kebab-case version of the input string.
     */
    camelCaseToKebabCase: str => {
        return str?.split('').map((letter, idx) => {
            return letter.toUpperCase() === letter && isNaN(letter) && letter !== '-'
                ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`
                : letter;
        }).join('');
    },
    /**
     * Convert string to camel case string
     * @param {string } str Input string
     * @returns {string} Camel cased string
     */

    toCamelCase: str => {
        return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
            if (+match === 0) return "";
            return index === 0 ? match.toLowerCase() : match.toUpperCase();
        });
    },
    /**
     * Strips HTML tags, comments, and optionally entities/content of specified tags from a string.
     * @param {string} str - Input string containing HTML.
     * @param {string[]} [removeContentOfTags=['title', 'style', 'script']] - Tags whose content should be removed.
     * @param {boolean} [removeEntities=true] - Whether to remove HTML entities.
     * @returns {string} The stripped string.
     */
    stripHtml(str, removeContentOfTags = ['title', 'style', 'script'], removeEntities = true) {
        if (typeof str !== 'string') return '';
        let tagsRegExp = Array.isArray(removeContentOfTags) && removeContentOfTags.length ? removeContentOfTags.reduce((a, b, i) => {
            return i === 1 ? `(<${a}.*>[\\w\\W]*?<\/${a}>)|(<${b}.*>[\\w\\W]*?<\/${b}>)|` : `${a}(<${b}.*>[\\w\\W]*?<\/${b}>)|`
        }) : '';
        let entityRegExp = removeEntities ? `|(&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});)` : '';
        let regularExpression = new RegExp(`${tagsRegExp}(<!--.*?-->)|(<!--[\\S\\s]+?-->)|(<!--[\\S\\s]*?$)|((<([^>]+)>)|(\\r\\n|\\n|\\r))${entityRegExp}`, 'gm');
        return str.replace(regularExpression, '').replace(/\s\s+/g, ' ').trim();
    },
    /**
     * Generates a FNV-1a hash from a string. Not cryptographically secure.
     * @param {string} str - The input string.
     * @returns {number} The 32-bit unsigned hash value.
     */
    fnv1a(str) {
        const FNV_prime = 16777619;
        const offset_basis = 2166136261;
        let hash = offset_basis;

        for (let i = 0; i < str.length; i++) {
            hash ^= str.charCodeAt(i);
            hash *= FNV_prime;
        }

        return hash >>> 0; // Unsigned 32-bit integer
    },

    /**
     * Gets the substring between two markers in a string.
     * @param {string} text - The input string.
     * @param {string} start - The starting marker.
     * @param {string} end - The ending marker.
     
    * @returns {string|null} The substring between start and end, or null if not found.
     */
    substring(text, start, end) {
        const startIndex = text.indexOf(start);
        if (startIndex === -1) return null; // start not found
        const endIndex = text.indexOf(end, startIndex + start.length);
        if (endIndex === -1) {
            // If end marker not found, return substring from start marker to end of text
            return text.substring(startIndex + start.length);
        }
        return text.substring(startIndex + start.length, endIndex);
    }

}
export default StringHelper;